module.exports = __webpack_public_path__ + "img/instagram-gradient-icon.1dd25497.png";